<template>
  <div class="qw-search-panel">
    <div class="qw-search-panel__form">
      <slot />
    </div>
    <div v-if="$slots.actions" class="qw-search-panel__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
// 查询条件面板：默认插槽放筛选控件，actions 插槽放查询/重置按钮
// 基础视觉由全局 layout.scss / business-page-theme.scss 的 .qw-search-panel 体系接管，
// scoped 仅保留全局没有的细节
export default {
    name: 'SearchPanel'
}
</script>

<style lang="scss" scoped>
.qw-search-panel__form {
    // flex 子项收缩保护，防止筛选控件被挤压溢出
    min-width: 0;

    ::v-deep .el-input__inner {
        height: 32px;
        line-height: 32px;
    }
}
</style>
